// extracted by mini-css-extract-plugin
var _1 = "active_release_flags--uv5SNxBL";
var _2 = "release_flag--iaMTXIEG";
export { _1 as "active_release_flags", _2 as "release_flag" }
